module.exports = __webpack_public_path__ + "static/media/queue.409fa242.svg";